import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import headerImg from "./assets/header.png";
import headerImgMb from "./assets/header-resize.jpg";
import kanbanImg from "./assets/kanban.png";
import aboutImg from "./assets/about.png";

const EVENT_ID = "n0008";

const aboutWalkContent = `此次路線的發想，在於1912年就讀臺灣總督府醫學校的賴和和杜聰明，行腳見學由水路來到三角，開啟了生命中重要的臺灣認同之路；也是八月十五迎尪公來三峽的舊路線，和三峽住民信仰交陪深厚。
`;

const credit = `
<div>
    <ul>
        <li style="list-style-type: cjk-ideographic;">
         本圖臺是由國立臺北大學海山學研究中心、三鶯社區大學並與智紳數位文化有限公司共同協力建置。
            <br><br>1. 圖臺內容：國立臺北大學海山學研究中心、三鶯社區大學以及大海山地方學研究社文史工作者團隊共同撰稿、攝影。
            <br><br>2. 圖臺系統開發：智紳數位文化事業有限公司
        </li>
        <br><br>
        <li style="list-style-type: cjk-ideographic;">
          本圖臺內容著作財產權由上述單位保有並授權國立臺北大學海山學研究中心、三鶯社區大學各項非商業行為使用，若有其他利用或授權需求請洽下列單位。
        </li>
    </ul>
</div>
<div style="display: flex; flex-direction: column; gap: 10px;">
  <span>
    國立臺北大學海山學研究中心
    <br>聯絡方式：02-86741111 #66506
  </span>
  <span>
    三鶯社區大學
    </br>聯絡方式：02-8671-2877
  </span>
</div>`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "行腳見學由水路來到三角",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "新北市", town: "三峽區" },
      { county: "新北市", town: "新店區" },
      { county: "臺北市", town: "文山區" },
    ],
  },
  themeConfig: {
    "--dui-primary": "#35BFA3",
    "--dui-accent": "#EAA625",
    "--dui-secondary": "#35BFA3",
    "--dui-bg-secondary": "#EB9D1D",
    "--dui-bg-accent": "#35BFA3",
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={`https://map.jsdc.com.tw/tools/checkin/n0008/showlist.php?a=${EVENT_ID}`}
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        latLng(24.911919878805968, 121.37072034180164),
        latLng(25.0219431151733, 121.55319638550282),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider
          {...duiConfigProps}
          sceneConfig={{ checkinKanbanImgSrc: kanbanImg }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
